import { DayContentProps } from "react-day-picker"

// A short note under a calendar day, as the booking app shows free spaces ("3 left", "Full").
export type DayNote = { text: string; full: boolean }
export type DayNotes = (date: Date) => DayNote | undefined

// Taller day cells, to fit the note under the date.
export const notedDayClassNames = {
  head_cell: "text-muted-foreground rounded-md w-11 font-normal text-[0.8rem]",
  cell: "h-12 w-11 text-center text-sm p-0 relative [&:has([aria-selected].day-range-end)]:rounded-r-md [&:has([aria-selected])]:bg-accent first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md focus-within:relative focus-within:z-20",
  day: "inline-flex h-12 w-11 items-center justify-center rounded-md p-0 font-normal hover:bg-gray-100 aria-selected:opacity-100",
  day_selected: "bg-primary text-white hover:bg-primary hover:text-white focus:bg-primary focus:text-white",
}

export const notedDayContent = (notes: DayNotes) => ({ date, displayMonth }: DayContentProps) => {
  const note = date.getMonth() === displayMonth.getMonth() ? notes(date) : undefined
  return (
    <span className="flex flex-col items-center leading-none">
      <span>{date.getDate()}</span>
      {note && <span className={`mt-1 text-[10px] ${note.full ? "text-status-rejected" : "opacity-70"}`}>{note.text}</span>}
    </span>
  )
}

// Days before today can't be booked, nor days with no space left.
export const unavailableDays = (notes?: DayNotes) => [{ before: new Date() }, (date: Date) => Boolean(notes?.(date)?.full)]
